import React, { useEffect, useState, useContext } from "react";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import styles from "./login.module.css";
import imagen1 from "./assets/Escudo.png";
import imagen4 from "./assets/4LogoPortal.png";
import LockIcon from "@mui/icons-material/Lock";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import WarningIcon from "@mui/icons-material/Warning";
import Lottie from "react-lottie-player";
import passwordAnimation from "./assets/Password.json";
import { useMediaQuery } from "@mui/material";
import mouseRojo from "./assets/animation360.json";
import { post } from "../../services/http";
import { useNavigate } from "react-router-dom";
import { ContextSession } from "../../services/ContextSession";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import {
  InputAdornment,
  IconButton,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  CircularProgress,
  Alert,
  TextField,
  Box,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import LiveHelpIcon from "@mui/icons-material/LiveHelp";
import CryptoJS from "crypto-js";

async function doLogin(event, flag) {
  event.preventDefault();
  let fla = flag ? 1 : 0;
  const data = new FormData(event.currentTarget);
  let email = data.get("email"),
    password = data.get("password");
  // let json = { username: email, password: password, ldap: fla };

  const secretKey = "2PQ2WI6oAxDYAaRDegWOsg9smJclabbYi7y3nFivisTBaDlHlE";
  // Convertir a string y encriptar con HMAC

  const encryptAES = (data, key) => {
    // Usar el método estándar de CryptoJS (que incluye salt y IV automáticamente)
    return CryptoJS.AES.encrypt(data, key).toString();
  };

  // Encriptar cada campo
  const encryptedEmail = encryptAES(email, secretKey);
  const encryptedPassword = encryptAES(password, secretKey);
  //const encryptedLdap = encryptAES(fla.toString(), secretKey);

  let json = {
    username: encryptedEmail,
    password: encryptedPassword,
    ldap: fla,
  };
  let url = "";

  // url = "http://127.0.0.1:8000/api/auth/ldap";
  url = "https://bei360.injupemp.gob.hn:8444/api/auth/ldap";
  //url = "http://172.20.7.10:8082/api/auth/ldap";

  //url="https://institutoalfonsohernandezcordova.com/Secretaria/Angular2/session.php";
  let datas = await post(url, json);

  return datas;
}

const SignInSide2 = () => {
  let sessi = useContext(ContextSession);
  const [isDominioActive, setIsDominioActive] = useState(true);
  const navigate = useNavigate();

  const toggle = (id) => {
    const container = document.getElementById("container");
    const imglogin = document.getElementById("imglogin");
    const imgsingg = document.getElementById("imgsing");
    const boxsign = document.getElementById("box-sign-up");
    if (container) {
      if (id === 1) {
        /*imgsingg.classList.add(styles['imgsingup']);
        imglogin.classList.add(styles['imglogin2']);
        boxsign.classList.add(styles['box-sign-up']);
        imglogin.classList.remove(styles['imglogin']);
        imgsingg.classList.remove(styles['imgsingup2']);*/
        setOpenDialog(true);
      } else {
        imgsingg.classList.add(styles["imgsingup2"]);
        imglogin.classList.add(styles["imglogin"]);
        imglogin.classList.remove(styles["imglogin2"]);
        imgsingg.classList.remove(styles["imgsingup"]);
        boxsign.classList.remove(styles["box-sign-up"]);
      }
      /*container.classList.toggle(styles['sign-in']);
      container.classList.toggle(styles['sign-up']);*/
    }
  };

  const [emailValue, setEmailValue] = useState("");
  const [passwordValue, setPasswordValue] = useState("");
  const [emailValid, setEmailValid] = useState(false);
  const [passwordValid, setPasswordValid] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [credencialesEmpty, setCredencialesEmpty] = useState(true);
  const [intentos, setIntentos] = useState(0);
  const [openDialog, setOpenDialog] = useState(false);
  const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false);
  const [errorMsg, setErrorMsg] = useState(""); // Mensaje de error
  const isMobile = useMediaQuery("(max-width:900px)"); // Detectar si es una pantalla móvil

  // Variables para el formulario de restablecimiento de contraseña
  const [dniValue, setDniValue] = useState("");

  const handleChange = (event) => {
    const newValue = event.target.value;
    const numericValue = newValue.replace(/\D/g, "");
    if (numericValue.length <= 13) {
      setDniValue(numericValue);
    }
  };

  const [correoValue, setCorreoValue] = useState("");
  const [errorMsgRestablecer, setErrorMsgRestablecer] = useState(""); // Mensaje de error en restablecimiento
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);
  const [loading, setLoading] = useState(false); // Estado para manejar el progreso de la carga
  const [openModal, setOpenModal] = useState(false); // Nuevo estado para el modal

  const validarEmpty = () => {
    let flag = true;
    if (emailValue.length >= 3 && passwordValue.length >= 3) flag = false;
    setCredencialesEmpty(() => flag);
  };

  const handleEmailChange = (event) => {
    setEmailValue(event.target.value);
    const email = event.target.value;
    setEmailValue(email);
    setEmailValid(email.length >= 3);
    validarEmpty();
  };

  const handlePasswordChange = (event) => {
    setPasswordValue(event.target.value);
    const password = event.target.value;
    setPasswordValue(password);
    setPasswordValid(password.length >= 3);
    validarEmpty();
  };

  const handleShowPassword = () => {
    setShowPassword((showPassword) => !showPassword);
  };

  const handleSubmit = async (event) => {
    event.preventDefault(); // Asegúrate de prevenir el comportamiento por defecto del formulario
    setLoading(true); // Mostrar el loading mientras se procesa la solicitud
    setSubmitButtonDisabled(true); // Deshabilitar el botón mientras se procesa

    try {
      let datas = await doLogin(event, isDominioActive);

      if (!datas.error) {
        sessi.setUsername(emailValue);
        sessi.sessionStart(datas);
        navigate("/Inicio");
      } else {
        setIntentos((prevIntentos) => prevIntentos + 1); // Actualizar correctamente los intentos
        if (intentos === 2) {
          setOpenDialog(true);
          setSubmitButtonDisabled(true);
        } else {
          setSubmitButtonDisabled(false); // Habilitar el botón si aún no se han alcanzado los 3 intentos
        }
      }
    } catch (error) {
      console.error("Error en el inicio de sesión:", error);
      setErrorMsg("Error en la solicitud. Por favor, inténtelo nuevamente.");
    } finally {
      setLoading(false); // Ocultar el loading una vez que se completa la solicitud
    }
  };

  useEffect(() => {
    const container = document.getElementById("container");
    const container2 = document.getElementById("my-container");
    const container3 = document.getElementById("my-container2");
    const imglogin = document.getElementById("imglogin");
    const imgsingg = document.getElementById("imgsing");
    imgsingg.classList.add(styles["imgsingup2"]);

    if (isMobile) {
      container2.style.zoom = "70%";
      container3.style.zoom = "70%";
    }

    if (container) {
      setTimeout(() => {
        container.classList.add(styles["sign-in"]);
        imglogin.classList.add(styles["imglogin"]);
      }, 200);
    }
  }, []);

  return (
    <div style={{ backgroundColor: "#f0f0f0" }}>
      <div id="container" className={styles.container}>
        <div className={styles.row}>
          <div
            className={`${styles.coll2} ${styles["align-items-center"]} ${styles["flex-col"]} ${styles["sign-up"]}`}
            id="my-container2"
          >
            <div
              className={`${styles["form-wrapper"]} ${styles["align-items-center"]}`}
            >
              <div
                id="box-sign-up"
                className={`${styles.form} ${styles["sign-up"]}`}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <a href="/">
                    <img
                      src={imagen4}
                      alt="imagen3"
                      style={{
                        width: !isMobile ? "220px" : "150px",
                        height: "auto",
                        marginRight: "2px",
                      }}
                    />
                  </a>
                  <Lottie
                    loop
                    animationData={mouseRojo}
                    play
                    style={{ width: "10%", height: "auto" }}
                  />
                </div>
                <TextField
                  margin="normal"
                  variant="outlined"
                  required
                  fullWidth
                  id="identidad"
                  placeholder={"Número de identidad"}
                  value={dniValue}
                  onChange={handleChange}
                  InputProps={{
                    startAdornment: (
                      <AccountCircleIcon
                        sx={{ marginRight: "8px", color: "grey" }}
                      />
                    ),
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "&:hover fieldset": { borderColor: "#72D2DA" },
                      "&.Mui-focused fieldset": { borderColor: "#72D2DA" },
                    },
                  }}
                />
                <TextField
                  margin="normal"
                  variant="outlined"
                  required
                  fullWidth
                  id="correo"
                  placeholder={"Correo Electrónico"}
                  value={correoValue}
                  onChange={(e) => setCorreoValue(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <ContactMailIcon
                        sx={{ marginRight: "8px", color: "grey" }}
                      />
                    ),
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "&:hover fieldset": { borderColor: "#72D2DA" },
                      "&.Mui-focused fieldset": { borderColor: "#72D2DA" },
                    },
                  }}
                />
                <button style={{ marginTop: 18 }}>Solicitar Cambio</button>
                {loading && <CircularProgress sx={{ marginTop: 2 }} />}
                {errorMsgRestablecer && (
                  <Alert
                    severity="error"
                    sx={{ marginTop: 2, marginBottom: 2 }}
                  >
                    {errorMsgRestablecer}
                  </Alert>
                )}
                <p>
                  <b onClick={() => toggle(2)} className={styles.pointer}>
                    Volver a iniciar sesión
                  </b>
                </p>
              </div>
            </div>
          </div>

          <div
            className={`${styles.coll} ${styles["align-items-center"]} ${styles["flex-col"]} ${styles["sign-in"]}`}
            id="my-container"
          >
            <div
              className={`${styles["form-wrapper"]} ${styles["align-items-center"]}`}
            >
              <div className={`${styles.form} ${styles["sign-in"]}`}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Lottie
                    loop
                    animationData={mouseRojo}
                    play
                    style={{ width: "20%", height: "auto" }}
                  />
                  <a>
                    <img
                      src={imagen4}
                      alt="imagen3"
                      style={{
                        width: !isMobile ? "220px" : "150px",
                        height: "auto",
                        marginTop: 13,
                      }}
                    />
                  </a>
                </div>

                <Box component="form" noValidate onSubmit={handleSubmit}>
                  <TextField
                    margin="normal"
                    variant="outlined"
                    required
                    fullWidth
                    id="email"
                    placeholder={"Ingresar Nombre de Usuario"}
                    name="email"
                    autoComplete="email"
                    autoFocus
                    value={emailValue}
                    onBlur={validarEmpty}
                    onChange={handleEmailChange}
                    InputProps={{
                      startAdornment: (
                        <AccountCircleIcon
                          sx={{ marginRight: "8px" }}
                          color={emailValue ? "disabled" : "action"}
                        />
                      ),
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        "&:hover fieldset": { borderColor: "#72D2DA" },
                        "&.Mui-focused fieldset": { borderColor: "#72D2DA" },
                      },
                    }}
                  />
                  <TextField
                    margin="normal"
                    variant="outlined"
                    required
                    fullWidth
                    name="password"
                    placeholder={"Ingresar Contraseña"}
                    type={showPassword ? "text" : "password"}
                    id="password"
                    autoComplete="current-password"
                    value={passwordValue}
                    onBlur={validarEmpty}
                    onChange={handlePasswordChange}
                    InputProps={{
                      startAdornment: (
                        <LockIcon
                          sx={{ marginRight: "8px" }}
                          color={passwordValue ? "disabled" : "action"}
                        />
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={handleShowPassword}
                            edge="end"
                            style={{
                              backgroundColor: "transparent",
                              color: "inherit",
                              // otros estilos específicos
                            }}
                          >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        "&:hover fieldset": { borderColor: "#72D2DA" },
                        "&.Mui-focused fieldset": { borderColor: "#72D2DA" },
                      },
                    }}
                  />

                  {intentos > 0 && (
                    <Alert severity="error">
                      Credenciales Invalidas, Intento {intentos}/3
                    </Alert>
                  )}

                  <button
                    disabled={credencialesEmpty || submitButtonDisabled}
                    style={{ marginTop: 18 }}
                  >
                    {loading ? (
                      <CircularProgress size={24} />
                    ) : (
                      "Iniciar Sesión"
                    )}
                  </button>
                  <p>
                    <b onClick={() => toggle(1)} className={styles.pointer}>
                      ¿Olvidó su contraseña?
                    </b>
                  </p>
                </Box>
              </div>
            </div>
          </div>
        </div>

        <div className={`${styles.row} ${styles["content-row"]}`}>
          <div
            className={`${styles.col} ${styles["align-items-center"]} ${styles["flex-col"]}`}
          >
            <div className={styles.img}>
              <img
                id="imglogin"
                src={imagen1}
                alt="welcome"
                className={styles.imglogin2}
              />
            </div>
          </div>

          <div
            className={`${styles.col} ${styles["align-items-center"]} ${styles["flex-col"]}`}
          >
            <div
              className={`${styles.img} ${styles["imgsingup2"]}`}
              id="imgsing"
            >
              <Lottie
                loop
                animationData={passwordAnimation}
                play
                style={{ width: !isMobile ? "50%" : "90%", height: "auto" }}
              />
            </div>
            {/*!isMobile && (
              <div className={`${styles.text} ${styles['sign-up']}`}>
                <h2 style={{ fontSize: isMobile ? 20 : 35 }}>Reestablecer</h2>
                <h2 style={{ fontSize: isMobile ? 20 : 35 }}>Contraseña</h2>
              </div>
            )*/}
          </div>
        </div>
      </div>

      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          {"¿Olvidó su contraseña?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            sx={{ textAlign: "justify" }}
          >
            Inicie sesión con sus credenciales de Windows. En caso de haber
            olvidado su contraseña, contacte con soporte técnico de la Unidad
            Técnica De Informática. Extensión 1234.
          </DialogContentText>
        </DialogContent>
        <DialogActions
          sx={{ display: "flex", justifyContent: "center", padding: 2 }}
        >
          <Button
            onClick={() => setOpenDialog(false)}
            variant="contained"
            style={{
              backgroundColor: "#72D2DA",
              borderColor: "#72D2DA",
              color: "#fff",
              fontWeight: "bold",
            }}
          >
            Aceptar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openSuccessDialog}
        onClose={() => setOpenSuccessDialog(false)}
        aria-labelledby="success-dialog-title"
      >
        <DialogTitle
          id="success-dialog-title"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          <CheckCircleIcon
            color="success"
            sx={{ fontSize: 40, marginRight: 1 }}
          />
          {" Solicitud de Cambio Exitosa"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="success-dialog-description"
            sx={{ textAlign: "justify" }}
          >
            La solicitud de cambio de contraseña se realizó con éxito. Los datos
            han sido enviados al correo electrónico proporcionado.
          </DialogContentText>
        </DialogContent>
        <DialogActions
          sx={{ display: "flex", justifyContent: "center", padding: 2 }}
        >
          <Button
            onClick={() => setOpenSuccessDialog(false)}
            variant="contained"
            style={{
              backgroundColor: "#72D2DA",
              borderColor: "#72D2DA",
              color: "#fff",
              fontWeight: "bold",
            }}
          >
            Aceptar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openModal}
        onClose={() => setOpenModal(false)}
        aria-labelledby="modal-title"
      >
        <DialogTitle
          id="modal-title"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          <CheckCircleIcon
            color="success"
            sx={{ fontSize: 40, marginRight: 1 }}
          />
          Sesión Finalizada
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="modal-description"
            sx={{ textAlign: "center" }}
          >
            Gracias por utilizar nuestros servicios.
          </DialogContentText>
        </DialogContent>
        <DialogActions
          sx={{ display: "flex", justifyContent: "center", padding: 2 }}
        >
          <Button
            onClick={() => setOpenModal(false)}
            variant="contained"
            style={{
              backgroundColor: "#72D2DA",
              borderColor: "#72D2DA",
              color: "#fff",
              fontWeight: "bold",
            }}
          >
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default SignInSide2;
